import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import Select, { type SelectProps } from '../../../Form/Select';
import type { HookInputBaseProps } from '../../types';

export interface HookSelectProps<T extends FieldValues = FieldValues> extends SelectProps, HookInputBaseProps<T> {
  name: FieldPath<T>;
}

export const HookSelect = <T extends FieldValues>(props: HookSelectProps<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const { control } = useFormContext<T>();
  const idOrName = id || name;

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error } }) => (
        <>
          <Select {...rest} {...field} id={idOrName} error={error?.message} />
        </>
      )}
    />
  );
};
